import { render } from "./ProjectEditPage.vue?vue&type=template&id=0b3eea92&scoped=true"
import script from "./ProjectEditPage.vue?vue&type=script&lang=js"
export * from "./ProjectEditPage.vue?vue&type=script&lang=js"

import "./ProjectEditPage.vue?vue&type=style&index=0&id=0b3eea92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3eea92"]])

export default __exports__